import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import cn from 'classnames';
import { BLOCK_META, BlockType } from './blockMeta';
import styles from '../../LessonEditor.module.css';

const DragDotsIcon = () => (
  <svg width="14" height="20" viewBox="0 0 16 22" fill="none" aria-hidden="true">
    <circle cx="5" cy="4" r="1.5" fill="currentColor" />
    <circle cx="11" cy="4" r="1.5" fill="currentColor" />
    <circle cx="5" cy="11" r="1.5" fill="currentColor" />
    <circle cx="11" cy="11" r="1.5" fill="currentColor" />
    <circle cx="5" cy="18" r="1.5" fill="currentColor" />
    <circle cx="11" cy="18" r="1.5" fill="currentColor" />
  </svg>
);

const TrashIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);

interface SortableBlockProps {
  id: string;
  type: BlockType;
  onDelete: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

export const SortableBlock: React.FC<SortableBlockProps> = ({
  id,
  type,
  onDelete,
  disabled = false,
  children,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const meta = BLOCK_META[type];
  const Icon = meta.icon;

  const cardStyle: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={cardStyle}
      className={cn(styles.card, { [styles.cardDragging]: isDragging })}
    >
      <span
        className={styles.handle}
        aria-label="Перетащить блок"
        {...attributes}
        {...listeners}
      >
        <DragDotsIcon />
      </span>

      <div className={styles.body}>
        <div className={styles.blockHead}>
          <span className={styles.blockType}>
            <Icon />
            {meta.label}
          </span>
          <div className={styles.actions}>
            <button
              type="button"
              className={cn(styles.actionBtn, styles.actionBtnDanger)}
              onClick={onDelete}
              disabled={disabled}
              aria-label="Удалить блок"
              title="Удалить блок"
            >
              <TrashIcon />
            </button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};
